import { Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros } from "@/utils/numberUtils";
import { ConsumableDto } from "@/core/features/consumables/consumable.dto";
import { ItemModelDto } from "@/core/features/item-models/item-model.dto";
import { ServiceDto } from "@/core/features/services/service.dto";
import { DeliveryNoteDto } from "@/core/features/delivery-notes/delivery-note.dto";
import { PurchaseOrderLineDto } from "@/core/features/purchase-orders/purchase-order-line.dto";
import { LocationDto } from "@/core/features/locations/location.dto";
import { ItemDto } from "@/core/features/items/item.dto";
import { StockRecordDto } from "@/core/features/stock-records/stock-record.dto";

export class DeliveryNoteLineDto extends BaseEntityDto {
  @Type(() => DeliveryNoteDto)
  deliveryNote: DeliveryNoteDto;
  deliveryNoteId: string;

  @Type(() => ItemModelDto)
  itemModel?: ItemModelDto;
  itemModelId?: string;

  @Type(() => ConsumableDto)
  consumable?: ConsumableDto;
  consumableId?: string;

  @Type(() => ServiceDto)
  service?: ServiceDto;
  serviceId?: string;

  @Type(() => PurchaseOrderLineDto)
  purchaseOrderLine?: PurchaseOrderLineDto;
  purchaseOrderLineId?: string;

  @Type(() => LocationDto)
  location?: LocationDto;
  locationId?: string;

  @Type(() => ItemDto)
  item?: ItemDto;

  @Type(() => StockRecordDto)
  stockRecord?: StockRecordDto;

  serialNumber?: string;

  notes?: string;

  quantity: number;

  @Transform(({ value }) => toEuros(value))
  unitPrice: number;

  toString() {
    const ref = this.itemModel?.toString() ?? this.consumable?.toString() ?? this.service?.toString() ?? "???";
    return `${ref} ×${this.quantity}`;
  }
}
